/* eslint-disable no-underscore-dangle */
/* eslint-disable no-console */
import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import Page from 'modules/_shared/components/Pages/Page';
import PageListHeader from 'modules/_shared/components/Headers/PageListHeader';
import AddBoard from 'modules/_shared/components/Modals/AddBoard';
import BoardCard from 'modules/boards/components/BoardCard';
import CustomLoading from 'modules/_shared/components/CustomLoading';
import { setModal } from 'modules/_shared/redux/modalActions';

import { useGetMenu } from 'modules/administratives/hooks/useGetMenu';
import { useBoardsList } from 'modules/boards/hooks/useBoardsList';
import { useGetBoardsSectionPermissions } from 'modules/boards/hooks/useGetBoardsSectionPermissions';

import { useGetActualSociety } from 'hooks/useGetActualSociety';
import BoardListBanner from '../../components/BoardListBanner';

const BoardsList: FC = () => {
  const { t } = useTranslate();
  const dispatch = useDispatch();
  const { societyId } = useParams();

  const { isAdmin, isReadOnly } = useGetBoardsSectionPermissions().data;
  const { data: boards, isLoading } = useBoardsList(societyId);

  useGetMenu();
  useGetActualSociety(societyId);

  const handleAddBoard = () => {
    if (isReadOnly) return;
    dispatch(setModal(<AddBoard board={null} />));
  };

  return (
    <Page id="boards-list">
      <PageListHeader
        subTitle={t('BoardPartners')}
        actions={[
          isAdmin && (
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleAddBoard}
              disabled={isReadOnly}
            >
              <span>{t('NewBoardCouncil')}</span>
            </button>
          ),
        ]}
      />

      <div className="nk-content-wrap">
        {boards?.length > 0 &&
          boards.map((board) => <BoardCard key={board._id} board={board} />)}
      </div>

      <div className="nk-block my-5">
        <BoardListBanner />
      </div>

      {isLoading && <CustomLoading />}
    </Page>
  );
};

export default BoardsList;
